import colorPallete from "@DSG/MobiusOverrides/styles/variables";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import { AutocompleteItemModel } from "@insite/client-framework/Types/ApiModels";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { Fragment } from "react";
import { css } from "styled-components";

interface Props {
    categories: AutocompleteItemModel[] | null;
    focusedItem?: AutocompleteItemModel;
    goToUrl: (url: string) => void;
    extendedStyles?: AutocompleteCategoriesStyles;
}

export interface AutocompleteCategoriesStyles {
    headerText?: TypographyPresentationProps;
    categoryItemText?: TypographyPresentationProps;
    focusedCategoryItemText?: TypographyPresentationProps;
    link?: LinkPresentationProps;
    focusedLink?: LinkPresentationProps;
    categoryLinkWrapper?: InjectableCss;
    categoryLinkMainWrapper?: InjectableCss;
}

export const autocompleteCategoriesStyles: AutocompleteCategoriesStyles = {
    categoryItemText: {
        css: css`
            width: 100%;
            text-align: left;
            cursor: pointer;
            display: flex;
        `,
    },
    focusedCategoryItemText: {
        css: css`
            width: 100%;
            text-align: left;
            cursor: pointer;
        `,
    },
    link: {
        typographyProps: {
            css: css`
                width: 100%;
                text-align: left;
            `,
        },
        css: css`
            width: auto;
            overflow: hidden;
            display: block;
        `,
    },
    focusedLink: {
        typographyProps: {
            css: css`
                width: 100%;
                text-align: left;
            `,
        },
        css: css`
            width: auto;
            overflow: hidden;
            display: block;
        `,
    },
    categoryLinkMainWrapper: {
        css: css`
            .autocomplete-categories-item-text {
                width: 100%;
                text-align: left;
                cursor: pointer;
                display: flex;
                &:not(:last-child) {
                    margin: 0 0 16px;
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        border: 1px solid ${colorPallete.grey300};
                        padding: 16px;
                        border-radius: 8px;
                    `,
                ],
                "max",
            )}
        `
    },
    categoryLinkWrapper: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    null,
                    css`
                        min-height: 408px
                    `,
                ],
                "min",
            )}
        `
    }
    
};

const styles = autocompleteCategoriesStyles;

class AutocompleteCategories extends React.Component<Props> {
    private readonly styles: AutocompleteCategoriesStyles;

    constructor(props: Props) {
        super(props);

        this.styles = mergeToNew(styles, props.extendedStyles);
    }

    render() {
        const { categories } = this.props;
        if (!categories || categories.length === 0) {
            return null;
        }

        const styles = this.styles;
        return (
            <StyledWrapper  {...styles.categoryLinkMainWrapper}>
                <Typography
                    {...styles.headerText}
                    as="h2" 
                    data-test-selector="autocompleteCategories_Header"
                    className="searchBlockHeading autocomplete-categories-header"
                >
                    {translate("Related Categories")}
                </Typography>
                <StyledWrapper  {...styles.categoryLinkWrapper} className="desktopOnlyBorder">
                    {categories.map(category => (
                        <Fragment key={`${category.id}`}>
                            {category.subtitle && (
                                <Typography
                                    {...(this.props.focusedItem === category
                                        ? styles.focusedCategoryItemText
                                        : styles.categoryItemText)}
                                    onClick={() => {
                                        this.props.goToUrl(category.url);
                                    }}
                                    className="autocomplete-categories-item-text"
                                >
                                    <Link {...styles.link} className="autocomplete-categories-item-link primaryLink bold">
                                        {category.displayTitle}
                                    </Link>
                                    {/* <>{` ${translate("in")}`}</> {category.displaySubtitle} */}
                                </Typography>
                            )}
                            {!category.subtitle && (
                                <Link
                                    {...(this.props.focusedItem === category ? styles.focusedLink : styles.link)}
                                    onClick={() => {
                                        this.props.goToUrl(category.url);
                                    }}
                                    className="autocomplete-categories-item-text primaryLink bold"
                                >
                                    {category.displayTitle}
                                </Link>
                            )}
                        </Fragment>
                    ))}
                </StyledWrapper>   
            </StyledWrapper>
        );
    }
}

export default AutocompleteCategories;
